/**
 * Use moment to format and validate dates with angular material
 */
export default function configMaterialDates($mdDateLocaleProvider, moment) {
  'ngInject';

  $mdDateLocaleProvider.formatDate = function(date) {
    return moment(date).format('l');
  };

  $mdDateLocaleProvider.parseDate = function(dateString) {
    let m = moment(dateString, 'l', true);
    return m.isValid() ? m.toDate() : new Date(NaN);
  };
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/l10n/md.dateformat.config.js